<app-navbar-style-two></app-navbar-style-two>

<div class="private-label-container">

  <!-- LEFT TEXT + RIGHT CONTENT -->
  <section class="intro-section">
    <div class="intro-left">
      <h2>Private Label Manufacturing</h2>
      <button class="primary-btn">Enquire Now</button>
    </div>

    <div class="intro-right">
      <p>
        Our Private Label Division is renowned for its unwavering commitment to superior quality,
        pioneering innovation, and robust partnerships with brand collaborators. We engage closely
        with clients to design and develop tailored products that seamlessly align with their specific
        market positioning and strategic objectives.
      </p>
      <p><b>Our capabilities include:</b></p>
      <ul>
        <li>Comprehensive design support with creative and innovative solutions.</li>
        <li>End-to-end R&D assistance to ensure product excellence.</li>
        <li>Product innovation tailored to brand requirements and consumer preferences.</li>
        <li>Global support from concept to production for developing innovative products.</li>
        <li>Seamless entry into international markets with consistent product quality.</li>
        <li>Empowering brands to grow across diverse global regions.</li>
        <li>Strengthening brand identity through reliable, high-quality private-label products.</li>
        <li>Compliance with industry standards and regulatory bodies (ISO, HACCP, HALAL, etc.).</li>
      </ul>
    </div>
  </section>

  <!-- CLIENTS -->
  <section class="clients-section">
    <h2>Our Clients</h2>

    <div class="clients-grid">
      <div class="client" *ngFor="let b of [1,2,3,4,5,6]">
        <img src="assets/img/private/{{b}}.png" alt="Brand {{b}}" />
      </div>
    </div>
  </section>

  <!-- PRODUCTS -->
  <section class="products-section">
    <h2>Our Products</h2>
    <p class="subtitle">
      Taste the difference with UNIKAI's wide range of products.
    </p>

    <div class="product-cards">
      <div class="card">
        <img src="assets/img/private/product-1.png" />
        <span>Ice cream</span>
      </div>

      <div class="card">
        <img src="assets/img/private/product-2.png" />
        <span>Dairy</span>
      </div>

      <div class="card">
        <img src="assets/img/private/product-3.png" />
        <span>Juices</span>
      </div>
    </div>
  </section>

  <!-- ENQUIRY FORM -->
  <section class="enquiry-section">
    <h2>Enquire Now</h2>
    <p>
      Submit your enquiry to UNIKAI through the form below, and our team will revert with the required support and
      guidance.
    </p>

    <form class="form-grid">
      <input type="text" placeholder="Name" />
      <div class="phone-input-wrapper">
        <div class="country-selector">
          <div class="country-code-select" (click)="toggleCountryDropdown($event)" [class.open]="showCountryDropdown">
            <span class="selected-flag">{{ selectedCountry?.flag }}</span>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 9L1 4H11L6 9Z" fill="#333"/>
            </svg>
          </div>
          <div class="country-dropdown" *ngIf="showCountryDropdown">
            <div 
              *ngFor="let country of countries" 
              class="country-option"
              (click)="selectCountry(country)"
              [class.selected]="country.code === selectedCountry?.code">
              <span class="flag">{{ country.flag }}</span>
            </div>
          </div>
        </div>
        <input type="tel" [(ngModel)]="mobileNumber" name="mobile" placeholder="Mobile" class="phone-input" />
      </div>
      <input type="email" placeholder="Email" />
      <div class="country-form-selector">
        <div class="country-form-select" (click)="toggleCountryFormDropdown($event)" [class.open]="showCountryFormDropdown">
          <span class="selected-country-name">{{ getCountryName(selectedCountryForm) }}</span>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9L1 4H11L6 9Z" fill="#333"/>
          </svg>
        </div>
        <div class="country-form-dropdown" *ngIf="showCountryFormDropdown">
          <div 
            *ngFor="let country of countries" 
            class="country-form-option"
            (click)="selectCountryForm(country.code)"
            [class.selected]="country.code === selectedCountryForm">
            <span>{{ country.name }}</span>
          </div>
        </div>
      </div>
      <select>
        <option>Subject</option>
        <option>General Enquiry</option>
        <option>Exports</option>
        <option>Private Label</option>
        <option>HORECA</option>
      </select>

      <button class="primary-btn">Submit</button>
    </form>
  </section>

  <!-- DOWNLOAD SECTION -->
  <section class="download-section">
    <div class="left">
      <h3>Download Brochure</h3>
      <p>Get detailed insights about our products and services</p>
    </div>
    <button class="primary-btn">Download Now</button>
  </section>

</div>


<app-footer-style-one></app-footer-style-one>